var _circle, _path, _path2, _path3, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGranCoupeDefault = function SvgGranCoupeDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.832,
    cy: 13.814,
    r: 0.885,
    stroke: "#1E242F",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M38.176 13.791a.885.885 0 1 1-1.77 0 .885.885 0 0 1 1.77 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M30.733 6.228c-2.564-1.576-6.871-2.142-9.233-2.294-.536-.034-.914.492-.733 1l.667 1.88a.76.76 0 0 0 .698.509c2.012.045 5.897.009 8.207-.009.664-.005.96-.738.394-1.086ZM19.476 4.752l.543 1.508a.777.777 0 0 1-.736 1.038 585 585 0 0 0-5.603.005c-.595.003-1.02-.673-.675-1.158.272-.382.648-.744 1.275-1.029 1.149-.52 3.09-.787 4.453-.865a.75.75 0 0 1 .743.501Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m10.287 14.338-4.934-1.155a.25.25 0 0 1-.12-.068l-.057-.058a2.38 2.38 0 0 1-.089-3.228v0a.25.25 0 0 0 .06-.167c-.008-.392.002-1.883.581-2.45a.53.53 0 0 1 .246-.124c1.39-.349 2.63-.646 3.572-.867a.7.7 0 0 0 .143-.049c1.114-.524 2.668-1.708 3.967-2.312C15.378 3.286 25.07.776 35.19 6.838c.07.042.149.074.228.092 2.405.546 4.326.728 7.843 2.145a.5.5 0 0 1 .24.182c.332.495 1.275 2.313.245 4.23a.7.7 0 0 1-.485.349l-3.578.74m-24.544 0h19.79"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.833,
    cy: 13.815,
    r: 2.331,
    stroke: "#1E242F",
    strokeWidth: 0.774
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M39.623 13.792a2.33 2.33 0 1 1-4.662 0 2.33 2.33 0 0 1 4.662 0Z"
  })));
};
export default SvgGranCoupeDefault;